import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, del } from './agent';

const pipelineActivities =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'pipeline-activities', id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query, { multi: true }).toString(true))),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: () => del(url),
    };
  };

export default pipelineActivities;
